module.exports = __webpack_public_path__ + "img/add-image.e1d1f9b3.svg";